import type { IChipItem } from "pro-features/components/MultiChipDown/src/MultiChipDownTypes";
import type { IChosenItem } from "../../../../../@types/chosenItems";
import type { IDataType } from "app/components/React/GraphTypeSwitcher/GraphTypeSwitcher";

interface IDisplayAd {
    Size: string;
    FirstDetected: string;
    Url: string;
    LastDetected: string;
    Type: number;
    HasPermission: boolean;
    CampaignUrl: string;
    ActiveDays: number;
    YearMonth: string[];
}

export interface IDisplayAdsProps {
    creatives: IDisplayAd[];
    totalCampaigns: number;
    totalPublishers: number;
    totalAdNetworks: number;
    totalCreatives: number;
    campaigns: IChipItem[];
    publishers: IChipItem[];
    adNetworks: IChipItem[];
    isCompare: boolean;
    is28d: boolean;
    selectedCampaigns: string[];
    selectedPublishers: string[];
    selectedAdNetworks: string[];
    isLoading: boolean;
    onPublishersFilterChange: (publishers) => void;
    onAdNetworksFilterChange: (networks) => void;
    onCampaignsFilterChange: (campaigns) => void;
    isClearAllDisabled: boolean;
    onClearAll: () => void;
    webSource: string;
    onSortChange: (sort) => void;
    initialSort: string;
    excelLink: string;
    onDomainFilterChange: (domain) => void;
    domains: IChosenItem[];
    selectedDomain: string;
}

interface IOverview {
    totalCampaigns: number;
    totalPublishers?: number;
    totalAdNetworks?: number;
    isLoading: boolean;
    getExcelEndpoint: () => string;
    getExcelReqBody: () => object;
    downloadExcelPermitted: boolean;
}

export interface ICreativesOverview extends IOverview {
    totalCreatives: number;
}

export interface IVideosOverview extends IOverview {
    totalVideos: number;
}

export interface IAdNetworksFilter {
    onAdNetworksFilterChange: (selectedAdNetworks) => void;
    adNetworks: IChipItem[];
    selectedAdNetworks: string[];
}

interface IMultichipdownProps {
    onSearch?: (term: string) => void;
    shouldShowCount?: boolean;
    searchFilter?: (term: string, item: IChipItem) => boolean;
    isLoading?: boolean;
    selector?: keyof IChipItem;
}

export interface ICampaignFilter extends IMultichipdownProps {
    campaigns: IChipItem[];
    selectedCampaigns: string[];
    onCampaignsFilterChange: (selectedCampaigns: IChipItem[]) => void;
}

export interface IPublishersFilter extends IMultichipdownProps {
    onPublishersFilterChange: (selectedPublishers) => void;
    publishers: IChipItem[];
    selectedPublishers: string[];
}

export interface IGalleryProps {
    initialTilesList: IDisplayAd[];
    webSource: string;
    onSortChange: (sort) => void;
    initialSort: string;
    params: any;
    selectedFilters: any;
    tilesEndpoint: string;
}

export interface ITilesContainer {
    initialTilesList: IDisplayAd[];
    params: object;
    selectedFilters: {
        selectedCampaigns: string[];
        selectedPublishers: string[];
        selectedAdNetworks: string[];
    };
    tilesEndpoint: string;
}

export const NUMBERS = "numbers";
export const PERCENTS = "percents";

export const availableDataTypes: IDataType[] = [
    { title: "#", value: NUMBERS, disabled: false },
    { title: "%", value: PERCENTS, disabled: false },
];
